import React from "react";

function Action() {

    // document.oncontextmenu = function (e) {
    //     console.log(e.button);
    //     if (e.button == 2) {
    //         e.preventDefault();
    //         return false;
    //     }

    // }

    // document.onkeydown=function(e)
    // {
    //   if(e.keyCode == 123)
    //   {
    //     return false;
    //   }

    //   if(e.ctrlKey && e.shiftKey && e.keyCode == 'I' .charCodeAt(0))
    //   {
    //     return false;
    //   }

    //   if(e.ctrlKey && e.shiftKey && e.keyCode == 'J' .charCodeAt(0))
    //   {
    //     return false;
    //   }

    //   if(e.ctrlKey && e.keyCode == 'U' .charCodeAt(0))
    //   {
    //     return false;
    //   }
    // }

    // // window.$(document).ready(function(){
    // //     window.$(document).on("contextmenu",function(e){
    // //         if(e.target.nodeName != "INPUT" && e.target.nodeName != "TEXTAREA")
    // //              e.preventDefault();
    // //      });
    // //  });

    // //  window.$('body').bind('copy',function(e) {
    // //     e.preventDefault(); return false; 
    // // });

    // window.$(document).keyup(function(e){
    //   if(e.keyCode == 44) return false;
    // });

    // document.addEventListener('keyup', (e) => {
    //     if (e.key == 'PrintScreen') {
    //         navigator.clipboard.writeText('');
    //         // alert('Screenshots disabled!');
    //     }
    // });

    // window.addEventListener('keydown', function(event) {
    //     if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && !event.altKey && (!event.shiftKey || window.chrome || window.opera)) {
    //         event.preventDefault();
    //         if (event.stopImmediatePropagation) {
    //             event.stopImmediatePropagation();
    //         } else {
    //             event.stopPropagation();
    //         }
    //         return;
    //         }
    // }, false);


    // window.oncontextmenu = function () {
    //             return false;
    //         }
    //         window.$(document).keydown(function (event) {
    //             if (event.keyCode == 123) {
    //                 return false;
    //             }
    //             else if ((event.ctrlKey && event.shiftKey && event.keyCode == 73) || (event.ctrlKey && event.shiftKey && event.keyCode == 74)) {
    //                 return false;
    //             }
    //         });



    //     // {----------------------------------------------------****************-------------------------****************------------------------}
    //     document.addEventListener("keyup", function (e) {
    //         var keyCode = e.keyCode ? e.keyCode : e.which;
    //                 if (keyCode == 44) {
    //                     stopPrntScr();
    //                 }
    //             });
    //     function stopPrntScr() {

    //                 var inpFld = document.createElement("input");
    //                 inpFld.setAttribute("value", ".");
    //                 inpFld.setAttribute("width", "0");
    //                 inpFld.style.height = "0px";
    //                 inpFld.style.width = "0px";
    //                 inpFld.style.border = "0px";
    //                 document.body.appendChild(inpFld);
    //                 inpFld.select();
    //                 // document.execCommand("copy");
    //                 inpFld.remove(inpFld);
    //             }
    //    function AccessClipboardData() {
    //         try {
    //             window.clipboardData.setData('text', "Access   Restricted");
    //         } catch (err) {
    //         }
    //     }
    //     setInterval("AccessClipboardData()", 300);

}

export default Action;